import * as React from 'react';
import {connect} from 'react-redux';

import {Session} from 'nutshell-core/session';

import type {NutshellState} from '../../../../store';

// @ts-expect-error
import * as actions from '../../dashboard-actions';

import {TodoFilters} from './todo-filters';
import {TodoListContainer} from './todo-list/todo-list-container';
import type {TodoPeriodSegment} from './todo-list/todo-list-controls/todo-list-controls';
// @ts-expect-error
import * as selectors from './todos-selectors';

import styles from './todos.module.css';

const mapStateToProps = function (state: NutshellState): StateProps {
    return {
        user: Session.getSessionStateUser(state),
        filter: selectors.getFilter(state),
        formattedDisplayDate: selectors.getFormattedDisplayDate(state),
        activePeriodSegment: selectors.getActivePeriodSegment(state),
        todoPastCount: selectors.getTodoPastCount(state),
        todoTodayCount: selectors.getTodoTodayCount(state),
        todoTomorrowCount: selectors.getTodoTomorrowCount(state),
        todoFutureCount: selectors.getTodoFutureCount(state),
    };
};

// @ts-expect-error
const mapDispatchToProps = function (dispatch): DispatchProps {
    return {
        onTodoPeriodSegmentSelected: (period: TodoPeriodSegment) => {
            dispatch(actions.updateTodoPeriodSegmentSelected(period));
            dispatch(actions.updatePeriodSegmentWasManuallySelected(true));
        },
    };
};

type OwnProps = Record<any, any>;

type StateProps = {
    user: any | null | undefined;
    filter: string;
    formattedDisplayDate: string;
    activePeriodSegment: TodoPeriodSegment;
    todoPastCount: number;
    todoTodayCount: number;
    todoTomorrowCount: number;
    todoFutureCount: number;
};

type DispatchProps = {
    onTodoPeriodSegmentSelected: (newPeriod: TodoPeriodSegment) => void;
};

type Props = OwnProps & StateProps & DispatchProps;

export class DashboardTodosComponent extends React.Component<Props> {
    render() {
        const {
            todoPastCount: past,
            todoTodayCount: today,
            todoTomorrowCount: tomorrow,
            todoFutureCount: future,
        } = this.props;
        const counts = {past, today, tomorrow, future} as const;
        const hasAssigneeFilter = Boolean(this.props.user && !this.props.user.isViewingRestricted);
        const canFilter = NutCapabilities.salesProcess.isAvailable || hasAssigneeFilter;

        return (
            <div className={styles.container}>
                {canFilter ? (
                    <TodoFilters
                        filter={this.props.filter}
                        hasSteps={NutCapabilities.salesProcess.isAvailable}
                        hasAssigneeFilter={hasAssigneeFilter}
                    />
                ) : undefined}
                <TodoListContainer
                    counts={counts}
                    formattedDisplayDate={this.props.formattedDisplayDate}
                    onPeriodSegmentChange={this.props.onTodoPeriodSegmentSelected}
                    activePeriodSegment={this.props.activePeriodSegment}
                />
            </div>
        );
    }
}

// @ts-expect-error
export const DashboardTodos = connect<Props, OwnProps, _, _, _, _>(
    mapStateToProps,
    mapDispatchToProps
)(DashboardTodosComponent);
